function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
export var HUB_IA_MENU_KEY = 'menu.chatbot_platform';
export var HUB_IA_V1_ROUTE = 'ProjectManagement';
var HUB_IA_V2_DEFAULT_URL = 'https://ia.inside.com.pe/';
var HUB_IA_V2_DEFAULT_LOGIN_URL = 'https://ia.inside.com.pe/auth/login';

// Entidades que conviven con ambas versiones durante la migración: solo a
// ellas se les ofrece elegir. El resto entra directo a V2.
export var HUB_IA_MIGRATION_COMPANIES = [{
  name: 'INTERCORP MANAGEMENT',
  code: '032',
  domains: ['intercorp.com.pe']
}, {
  name: 'INNOVA SCHOOLS PERU',
  code: '021',
  domains: ['innovaschools.edu.pe']
}, {
  name: 'Innova Colombia',
  code: '021001',
  domains: ['innovaschools.edu.co']
}, {
  name: 'Casa Andina',
  code: '014',
  domains: ['casa-andina.com']
}, {
  name: 'FINANCIERA OH!',
  code: '012',
  domains: ['somosoh.pe']
}, {
  name: 'SUPERMERCADOS PERUANOS',
  code: '010',
  domains: ['spsa.pe']
}, {
  name: 'INRETAIL',
  code: '059',
  domains: ['indigitalxp.pe', 'intercorpretail.pe']
}, {
  name: 'INTERBANK',
  code: '000',
  domains: ['interbank.pe']
}, {
  name: 'La Tinka',
  code: '003',
  domains: ['latinka.com.pe']
}, {
  name: 'SMI',
  code: '039',
  domains: ['smi.com.pe']
}];

// Los códigos llegan con o sin ceros a la izquierda según el origen ('32' / '032').
function normalizeCompanyCode(code) {
  if (code === null || code === undefined) {
    return '';
  }
  return String(code).trim().replace(/^0+(?=\d)/, '');
}
function normalizeDomain(domain) {
  if (!domain) {
    return '';
  }
  return String(domain).trim().toLowerCase();
}
export default {
  name: 'HubIaMigrationDialog',
  data: function data() {
    return {
      versionSelected: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode'])), {}, {
    userDomain: function userDomain() {
      return normalizeDomain(window.userInfo && window.userInfo.domain);
    },
    // Sin ningún identificador cargado no se asume nada: se muestra el modal
    // antes que sacar al usuario de la plataforma por error.
    isMigrationCompany: function isMigrationCompany() {
      var code = normalizeCompanyCode(this.companyCode);
      var domain = this.userDomain;
      if (!code && !domain) {
        return true;
      }
      return HUB_IA_MIGRATION_COMPANIES.some(function (company) {
        return !!code && normalizeCompanyCode(company.code) === code || !!domain && company.domains.some(function (item) {
          return normalizeDomain(item) === domain;
        });
      });
    },
    v2Url: function v2Url() {
      return process.env.VUE_APP_HUB_IA_V2_URL || HUB_IA_V2_DEFAULT_URL;
    },
    v2LoginUrl: function v2LoginUrl() {
      return process.env.VUE_APP_HUB_IA_V2_LOGIN_URL || HUB_IA_V2_DEFAULT_LOGIN_URL;
    },
    v2Features: function v2Features() {
      return [this.traductor('chatbots.hub_ia_migration.v2_feature_board'), this.traductor('chatbots.hub_ia_migration.v2_feature_wizard'), this.traductor('chatbots.hub_ia_migration.v2_feature_sandbox'), this.traductor('chatbots.hub_ia_migration.v2_feature_metrics')];
    }
  }),
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onOpen: function onOpen() {
      this.versionSelected = null;
      // Fuera de las entidades en migración no hay nada que elegir: V2 es su
      // única plataforma, así que se entra directo en esta misma pestaña.
      if (!this.isMigrationCompany) {
        this.$emit('select', 'v2');
        window.location.assign(this.v2LoginUrl);
        return;
      }
      this.$refs.dialog.onOpen();
    },
    onClose: function onClose() {
      this.$refs.dialog.onClose();
    },
    // V1: se mantiene en la misma pestaña, sobre la plataforma actual.
    onSelectV1: function onSelectV1() {
      this.versionSelected = 'v1';
      this.onClose();
      this.$store.commit('app/setMenuSelected', HUB_IA_MENU_KEY);
      if (this.$route.name !== HUB_IA_V1_ROUTE) {
        this.$router.push({
          name: HUB_IA_V1_ROUTE
        });
      }
      this.$emit('select', 'v1');
    },
    // V2: vive fuera de esta app, se abre en una pestaña nueva.
    onSelectV2: function onSelectV2() {
      this.versionSelected = 'v2';
      this.onClose();
      window.open(this.v2Url, '_blank');
      this.$emit('select', 'v2');
    },
    onDismiss: function onDismiss() {
      if (!this.versionSelected) {
        this.$emit('dismiss');
      }
    }
  }
};